<template>
  <div class="mt-4">
    <div class="flex justify-between">
      <div v-if="item.label">
        <TText size="base" classes="m-0" variant="semibold">{{
          item.label
        }}</TText>
      </div>

      <div v-if="item.value">
        <TText size="lg" classes="m-0 text-end">{{ toEuro(item.value) }}</TText>
      </div>
    </div>
    <TText v-if="item.message" size="sm" classes="mb-0">{{
      item.message
    }}</TText>
  </div>
</template>
<script setup lang="ts">
import type { CottageContactWhatsAppPagePricesResponse } from '../entities/CottageContactWhatsAppPagePrices'

interface propsInterface {
  item: CottageContactWhatsAppPagePricesResponse
}

defineProps<propsInterface>()
</script>
